import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

export default function Gallery() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pb-24">
      <section className="border-b border-ink/10 py-20" aria-labelledby="gallery-title">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="tag mb-3">{t("gallery.eyebrow")}</div>
          <h1 id="gallery-title" className="font-display font-black text-ink text-5xl sm:text-6xl leading-[1]">
            {t("gallery.title_a")} {t("gallery.title_b") && <span className="text-teal">{t("gallery.title_b")}</span>}.
          </h1>
          <p className="mt-6 text-ink/70 max-w-2xl leading-relaxed">{t("gallery.intro")}</p>
        </div>
      </section>

      <section className="py-10" aria-label={t("nav.gallery")}>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {items.map((g, i) => (
            <button
              key={g.id}
              data-testid={`gallery-item-${g.id}`}
              onClick={() => setActive(g)}
              className="block w-full break-inside-avoid group relative border border-ink/10 overflow-hidden text-left"
              style={{ aspectRatio: i % 3 === 0 ? "4/5" : i % 3 === 1 ? "1/1" : "3/4" }}
              aria-label={g.caption}
            >
              <img src={g.url} alt="" aria-hidden="true" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity flex items-end p-4">
                <p className="text-white text-sm">{g.caption}</p>
              </div>
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
          aria-label={active.caption}
        >
          <img src={active.url} alt={active.caption} className="max-h-[90vh] max-w-[90vw] object-contain" />
          <div className="absolute bottom-6 left-0 right-0 text-center text-white/90 text-sm">{active.caption}</div>
        </div>
      )}
    </div>
  );
}
